import { useTranslation } from 'react-i18next';

export function useLanguagePreference() {
  const { i18n } = useTranslation();

  const currentLocale = i18n.language || 'en';

  const switchLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18n_language', lang);
  };

  return {
    currentLocale,
    switchLanguage,
  };
}
